import type { MomentInput } from 'moment';
import {
	normalizeHierarchyEndDate,
	normalizeHierarchyStartDate
} from '@/components/Settings/DataExtraction/utils/hierarchyEndDate';

type GeneralInformationValues = {
	organization_id: string;
	company_id: string;
	sector_id?: string | null;
	line_id?: string | null;
	workstation_id?: string | null;
	name?: string;
	initial_date?: MomentInput | null;
	final_date?: MomentInput | null;
};

export function normalizeGeneralInformationPayload(values: GeneralInformationValues) {
	return {
		organization_id: values.organization_id,
		company_id: values.company_id,
		sector_id: values.sector_id ?? null,
		line_id: values.line_id ?? null,
		workstation_id: values.workstation_id ?? null,
		extraction_name: values.name,
		start_date: normalizeHierarchyStartDate(values.initial_date),
		end_date: normalizeHierarchyEndDate(values.final_date),
		extraction_type: 'hierarchy' as const
	};
}
